import React from "react";
import "./Footer.css";

export default function Footer() {
    return (
        <div className="footer-eop-container">
            <img
          src={require('../../assets/Home/shape-bg.png')}
          alt="img failed to load"
        />
        </div>
    )
}